export default "__VITE_ASSET__d3f03da0__"